// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/assay_data.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_quanterix_common_extensions_v1_field_options } from "../../../common/extensions/v1/field_options_pb";
import type { AssayCoreConfig } from "./assay_core_config_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_assay_core_config } from "./assay_core_config_pb";
import type { AssayMetadata } from "./assay_metadata_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_assay_metadata } from "./assay_metadata_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/assay_data.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_assay_data: GenFile = /*@__PURE__*/
  fileDesc("CjhxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvYXNzYXlfZGF0YS5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxIo8CCglBc3NheURhdGESHQoIYXNzYXlfaWQYASABKAlCBoK1GAIgAUgAiAEBElgKEWFzc2F5X2NvcmVfY29uZmlnGAIgASgLMjgucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLkFzc2F5Q29yZUNvbmZpZ0gBiAEBElMKDmFzc2F5X21ldGFkYXRhGAMgASgLMjYucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLkFzc2F5TWV0YWRhdGFIAogBAUILCglfYXNzYXlfaWRCFAoSX2Fzc2F5X2NvcmVfY29uZmlnQhEKD19hc3NheV9tZXRhZGF0YWIGcHJvdG8z", [file_quanterix_common_extensions_v1_field_options, file_quanterix_simoa_one_analysis_app_api_v1_assay_core_config, file_quanterix_simoa_one_analysis_app_api_v1_assay_metadata]);

/**
 * Represents the top-level container for information that describes an assay,
 * including metadata and configuration parameters required for analysis.
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.AssayData
 */
export type AssayData = Message<"quanterix.simoa_one.analysis_app_api.v1.AssayData"> & {
  /**
   * Unique identifier (UUID) of the assay associated with this config
   *
   * For backward-compatibility with existing "Protocol" and "Definition"
   * assay messages, this field should be mapped to `*_protocol_id`, however,
   * the concepts of assay "protocol" and "definition" are not applicable
   * to this message and is children.
   *
   * @generated from field: optional string assay_id = 1;
   */
  assayId?: string;

  /**
   * Contains core assay configuration information for use in analysis
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.AssayCoreConfig assay_core_config = 2;
   */
  assayCoreConfig?: AssayCoreConfig;

  /**
   * Contains supplemental information about the assay
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.AssayMetadata assay_metadata = 3;
   */
  assayMetadata?: AssayMetadata;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.AssayData.
 * Use `create(AssayDataSchema)` to create a new message.
 */
export const AssayDataSchema: GenMessage<AssayData> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_assay_data, 0);

